/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * ---------------------------------------------------------------------------------------------------------------
 * GIFT CARD RECIPIENT FORM ("I want to send this as a gift")
 *
 * Progressive enhancement for snippets/gift-card-recipient-form.liquid. This mirrors Shopify's own reference
 * implementation: the checkbox is only usable once JavaScript runs, the "if_present" fallback control field is
 * disabled, and the recipient fields are enabled/disabled (and cleared) along with the checkbox so that nothing is
 * ever submitted when the shopper does not send the gift card to someone else.
 * ---------------------------------------------------------------------------------------------------------------
 */

(function() {
  'use strict';

  var RECIPIENT_SELECTOR = '[data-gift-card-recipient]';

  /**
   * Returns today's date as YYYY-MM-DD in the *visitor* timezone (toISOString() alone would return the UTC day,
   * which is off by one for a large part of the world).
   */
  function localToday() {
    var now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());

    return now.toISOString().slice(0, 10);
  }

  function setupRecipientForm(recipientForm) {
    if (recipientForm.hasAttribute('data-recipient-ready')) {
      return;
    }

    var checkbox = recipientForm.querySelector('[data-recipient-checkbox]');

    if (!checkbox) {
      return;
    }

    recipientForm.setAttribute('data-recipient-ready', 'true');

    var controlField = recipientForm.querySelector('[data-recipient-control]'),
        offsetField = recipientForm.querySelector('[data-recipient-offset]'),
        liveRegion = recipientForm.querySelector('[data-recipient-live-region]'),
        emailField = recipientForm.querySelector('[data-recipient-input="email"]'),
        sendOnField = recipientForm.querySelector('[data-recipient-input="send_on"]'),
        inputFields = Array.prototype.slice.call(recipientForm.querySelectorAll('[data-recipient-input]'));

    // The checkbox is disabled in the markup so that non-JS visitors fall back to the "if_present" behavior
    checkbox.disabled = false;

    if (controlField) {
      controlField.disabled = true;
    }

    if (offsetField) {
      offsetField.value = new Date().getTimezoneOffset().toString();
    }

    // Shopify refuses a scheduled date in the past, so we let the browser say so before the request is made
    if (sendOnField && sendOnField.type === 'date' && !sendOnField.getAttribute('min')) {
      sendOnField.setAttribute('min', localToday());
    }

    function onChange() {
      var isSendingGift = checkbox.checked;

      inputFields.forEach(function(field) {
        if (!isSendingGift) {
          field.value = '';
        }

        field.disabled = !isSendingGift;
      });

      if (offsetField) {
        offsetField.disabled = !isSendingGift;
      }

      if (emailField) {
        if (isSendingGift) {
          emailField.setAttribute('required', 'required');
        } else {
          emailField.removeAttribute('required');
        }
      }

      if (liveRegion) {
        liveRegion.textContent = recipientForm.getAttribute(isSendingGift ? 'data-expanded-text' : 'data-collapsed-text') || '';
      }
    }

    // The listener lives on the checkbox itself, so it is garbage collected together with the section it belongs to
    checkbox.addEventListener('change', onChange);
    onChange();
  }

  function initRecipientForms(container) {
    var scope = container && container.querySelectorAll ? container : document;

    Array.prototype.forEach.call(scope.querySelectorAll(RECIPIENT_SELECTOR), setupRecipientForm);
  }

  /**
   * Re-applies the enabled/disabled state of every recipient form currently in the document. The DOM is queried on
   * every call on purpose: nothing is kept in a registry, so removed sections are never retained in memory.
   */
  function syncRecipientForms(container, uncheckFirst) {
    var scope = container && container.querySelectorAll ? container : document;

    Array.prototype.forEach.call(scope.querySelectorAll(RECIPIENT_SELECTOR), function(recipientForm) {
      var checkbox = recipientForm.querySelector('[data-recipient-checkbox]');

      if (!checkbox) {
        return;
      }

      if (uncheckFirst) {
        if (!checkbox.checked) {
          return;
        }

        checkbox.checked = false;
      }

      // Deliberately non-bubbling so no other theme or app listener is triggered by this internal sync
      checkbox.dispatchEvent(new CustomEvent('change'));
    });
  }

  /**
   * The add to cart is done in Ajax, which bypasses the native form validation. We therefore make sure a recipient
   * email was filled in before letting the theme add the line item to the cart.
   */
  document.addEventListener('click', function(event) {
    var target = event.target;
    var button = target && target.closest ? target.closest('[data-action="add-to-cart"]') : null;

    if (!button) {
      return;
    }

    var productForm = button.closest('form[action*="/cart/add"]');

    if (!productForm) {
      return;
    }

    var recipientForm = productForm.querySelector(RECIPIENT_SELECTOR);

    if (!recipientForm) {
      return;
    }

    var checkbox = recipientForm.querySelector('[data-recipient-checkbox]'),
        emailField = recipientForm.querySelector('[data-recipient-input="email"]');

    if (!checkbox || !checkbox.checked || !emailField || typeof emailField.checkValidity !== 'function') {
      return;
    }

    if (emailField.checkValidity()) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (typeof emailField.reportValidity === 'function') {
      emailField.reportValidity();
    } else {
      emailField.focus();
    }
  }, true);

  // Once the gift card has been added to the cart, we reset the form so the next add to cart starts clean
  document.addEventListener('product:added', function(event) {
    syncRecipientForms(event.target, true);
  });

  // Theme editor support: the section is replaced by a brand new node, which is set up from scratch
  document.addEventListener('shopify:section:load', function(event) {
    initRecipientForms(event.target);
  });

  /**
   * Browsers restore form values on a back navigation (and on a bfcache restore, where no script runs at all). This
   * happens after our setup, so the checkbox can end up checked while the fields are still disabled. Re-syncing on
   * "pageshow" keeps both in agreement.
   */
  window.addEventListener('pageshow', function() {
    initRecipientForms();
    syncRecipientForms();
  });

  initRecipientForms();
})();
